const tokenStorageKey = 'token';

export const useTokenStorage = () => ({
  getToken: () => localStorage.getItem(tokenStorageKey),
  setToken: (token: string) => localStorage.setItem(tokenStorageKey, token),
  clearToken: () => localStorage.removeItem(tokenStorageKey),
});
